export class Client {
  static getVariance(client, defaultValue = null) {
    return client.avg_variance !== null
      ? `${client.avg_variance}%`
      : defaultValue;
  }
}



// WEBPACK FOOTER //
// ./src/domain/client.js